import * as React from 'react';
import { AnalyticsStore } from 'bernie-core';
import { UitkMessagingCard, UitkMessagingCardSection } from 'uitk-react-messaging-cards';
import { ActivityDestinationViewSearch } from '../../../common/__generated__/api';
import { BannerMedia } from '../../../components/common/banners/banner-media';
import { mapMessagingCardMediaProps, mapMessagingCardSectionProps } from './activity-message-banner-helper';
import Icon = ActivityDestinationViewSearch.Icon;
import Mark = ActivityDestinationViewSearch.Mark;

interface MessageBannerProps {
  headerText?: string | null;
  bodyText?: string | null;
  className?: string;
  icon?: Icon | null;
  mark?: Mark | null;
  linkUrl?: string | null;
  linkText?: string | null;
  linkRfrr?: string | null;
  analyticsStore?: AnalyticsStore;
}

export const MessageBanner: React.FC<MessageBannerProps> = ({
  headerText,
  bodyText,
  className,
  icon,
  mark,
  linkUrl,
  linkText,
  linkRfrr,
  analyticsStore
}) => {
  const firstAction: ActivityDestinationViewSearch.First = {
    text: linkText,
    clickAction: {
      __typename: 'ActivityLinkClickAction',
      anchorTagUrl: linkUrl,
      linkTagUrl: null,
      opensInNewTab: false,
      accessibilityText: '',
      analytics: {
        referrerId: linkRfrr || '',
        linkName: ''
      }
    }
  };

  return (
    <aside className={className} data-testid="message-banner">
      <UitkMessagingCard {...mapMessagingCardMediaProps(icon, mark)}>
        <BannerMedia icon={icon} mark={mark} />
        <UitkMessagingCardSection
          {...mapMessagingCardSectionProps(analyticsStore, headerText, firstAction, null)}
          data-testid="message-banner-primary-text"
        >
          {bodyText && (
            <p className="uitk-type-300" data-testid="message-banner-secondary-text">
              {bodyText}
            </p>
          )}
        </UitkMessagingCardSection>
      </UitkMessagingCard>
    </aside>
  );
};
